module.exports = __webpack_public_path__ + "img/04d-Shop_651.2fc95ae0.jpg";